import { Component, EventEmitter, input, Output } from '@angular/core';
import { BreadcrumbItem } from "@qai/ui";
import { TranslationService } from 'src/app/services/translation.service';
import { TranslocoService } from '@jsverse/transloco';
import { ActivatedRoute, Router } from '@angular/router';
import { LocaleService } from 'src/app/services/locale.service';
import { PathwaysService } from 'src/app/services/learner/pathways.service';
import { IPathwayDetailResponse } from 'src/app/interfaces/ipathway-details-response';

@Component({
  selector: 'app-pathway-detail-header',
  standalone: false,
  templateUrl: './pathway-detail-header.component.html',
  styleUrl: './pathway-detail-header.component.scss'
})
export class PathwayDetailHeaderComponent {
  completedAt = input<string | null>(null);
  @Output() pathwayName = new EventEmitter<string>();
  isTranslationLoaded = false;
  isLoading = false;
  moduleAssignmentUuid: string = '';
  pathwayDetails: IPathwayDetailResponse | undefined;

  get formattedCompletedAt(): string {
    const value = this.completedAt();
    if (!value) return '';
    const label = this.translocoService.translate('COMPLETED', {}, 'learningPathway');
    return `${label} ${this.localeService.formatDate(value)}`;
  }

  constructor(
    private translationService: TranslationService,
    private translocoService: TranslocoService,
    private route: ActivatedRoute,
    private localeService: LocaleService,
    private pathwaysService: PathwaysService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.translationService
      .loadScopedTranslation('learningPathway')
      .then(() => {
        this.isTranslationLoaded = true;

        this.route.queryParams.subscribe((params) => {
          this.moduleAssignmentUuid = params['moduleAssignmentUuid'];

          if (this.moduleAssignmentUuid) {
            this.fetchPathwayDetails(this.moduleAssignmentUuid);
          } else {
            console.error(
              'Module assignment UUID not found in query params, redirecting to learner dashboard'
            );
            this.goToLearnerDashboard();
          }
        });
      });
  }

  fetchPathwayDetails(moduleAssignmentUuid: string): void {
    this.isLoading = true;
    const includeStepInfo = false;
    this.pathwaysService.getPathwayDetails(moduleAssignmentUuid, includeStepInfo).subscribe({
      next: (response: IPathwayDetailResponse) => {
        this.pathwayDetails = {
          ...response,
          pathwayDueDate: this.localeService.formatDate(response.pathwayDueDate),
        };
        this.pathwayName.emit(response.pathwayName ?? '');
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading pathway details:', error);
        this.isLoading = false;
      }
    });
  }

  getBreadcrumbItems(): BreadcrumbItem[] {
    return [
      {
        text: this.translocoService.translate('ASSIGNMENTS', {}, 'learningPathway'),
        href: '/assignments',
      },
    ];
  }

  goToLearnerDashboard(): void {
    localStorage.setItem('returnUrl', '/assignments');
    this.router.navigate(['/assignments']);
  }
}
